import type { Feature } from 'geojson';
import { GöteborgsStadSource } from './GöteborgsStadSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions: AjaxSourceOptions = {
    id: 'pump-station-source',
    jsonp: true,
    displayName: 'Cykelpumpar',
};

interface PumpStation {
    iD: string;
    name: string;
    address: string;
    lat: number;
    lon: number;
}

export interface PumpStationProperties {
    name: string;
    address: string;
}

export class PumpStationSource extends GöteborgsStadSource {
    constructor(options?: AjaxSourceOptions) {
        super('BikeService/v1.2/PumpStations/', { ...defaultOptions, ...options });
    }

    parseData = (stations: PumpStation[]): Feature[] => {
        return stations.map(
            (station) =>
                ({
                    id: station.iD,
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [station.lon, station.lat],
                    },
                    properties: {
                        name: station.name,
                        address: station.address,
                    },
                }) as Feature,
        );
    };
}
